{
  "actionCannotBeUndone": "Denne handlingen kan ikke angres.",
  "activeMembers": "Aktive medlemmer",
  "addContact": "Legg til kontakt",
  "addInterestAreaInSettings": "Fant ingen interesseområder. Gå til <1>kontoinnstillinger</1> for å opprette nye.",
  "attachContactToMember": "Knytt kontakt til medlem",
  "bankrupt": "Konkurs",
  "bisnode.balance": "Balanse",
  "bisnode.result": "Driftsresultat",
  "bisnode.revenue": "Omsetning",
  "bisnode.staffCosts": "Lønnskostnader",
  "brreg.addWithoutBrreg": "Legg til uten Brønnøysundsregistrene",
  "brreg.description": "Vi henter fram nøkkelopplysninger om alle virksomheter som pr. i dag er registrert i Brønnøysundregistrene. Du kan søke på navn, eller på organisasjonsnummer hvis du kjenner det.",
  "brreg.notFindingTheCompany.description": "Hvis du ønsker å registrere bedriften uten Brønnøysundsregisteret så kan du legge inn informasjonen manuelt.",
  "brreg.notFindingTheCompany.title": "Finner du ikke bedriften?",
  "brreg.notFound": "Ikke funnet i BRREG.",
  "brreg.searchHelpText": "Her kan du søke etter bedriftens navn, eller organisasjonsnummer.",
  "brreg.SearchHitOver20": "Søket gav mer enn {{ total }} treff. Her vises de {{ length }} første. Velg fra listen eller juster søket.",
  "brreg.SearchHits": "Søket gav {{ total }} treff.",
  "brreg.searchLabel": "Søk i Brønnøysundsregistrene",
  "brreg.searchPlaceholder": "Bedriftsnavn eller organisasjonsnummer",
  "brreg.searhcNoHits": "Søket ga 0 treff. Prøv å søke etter noe annet.",
  "brreg.somethingWentWrong": "Noe gikk galt, prøv å skrive inn en ny verdi.",
  "changeInNumberOfEmployees": "Endring antall årsverk",
  "changeType": "Endre type",
  "changeType.error": "Kunne ikke endre type. Vennligst prøv igjen.",
  "collaborators": "Samarbeidspartnere",
  "invoices": "Fakturering",
  "companyInformation": "Selskapsinformasjon",
  "companyInformation.update.error": "Kunne ikke oppdatere selskapsinformasjon. Vennligst prøv igjen.",
  "companyNotFound": "Kunne ikke finne bedrift!",
  "companyType": "Selskapsform",
  "companyTypeCode": "Selskapsform kode",
  "confirm.deletion": "Bekreft at du ønsker å slette disse.",
  "confirmDelete.associate.question": "Er du sikker på at du vil slette disse samarbeidspartnerne, og alle kontakter som er knyttet til dem?",
  "confirmDelete.contact.question": "Er du sikker på at du vil slette disse kontaktene?",
  "confirmDelete.lead.question": "Er du sikker på at du vil slette disse leads, og alle kontakter som er knyttet til dem?",
  "confirmDelete.member.question": "Er du sikker på at du vil slette disse medlemmene, og alle kontakter som er knyttet til dem?",
  "confirmDeleteMembersQuestion": "Er du sikker på at du vil slette disse medlemmene, og alle kontakter som er knyttet til med?",
  "confirmRemoveContactsFromMember": "Er du sikker på at du vil fjerne disse kontaktene fra denne bedriften? Antall: {{ count }}.",
  "contactChangeCompanyNotification": "Kontakter som allerede er knyttet opp mot en bedrift, vil miste sin kobling, og bli knyttet til denne bedriften.",
  "contactDetails.inkind.description": "Her ligger alle egeninnsats registrert hos kontakten",
  "contactList.description": "Legg til medlembredriftens kontaktpersoner. Ønsker du ikke å gjøre det nå, så kan du hoppe over og legge dem til senere.",
  "contacts": "Kontakter",
  "contactsRemovedFromMembersStillActive": "Kontaktene fjernes nå fra medlemmene, men er fortsatt aktive.",
  "couldNotRemoveParticipants": "Klarte ikke fjerne deltagere. Prøv på nytt.",
  "createCustomer": "Opprett kunde",
  "dataSavedAutomatically": "Dataene du legger inn blir lagret automatisk.",
  "delete.associate.error": "Kunne ikke slette disse samarbeidspartnerne. Vennligst prøv igjen.",
  "delete.associate.modal.title": "Slett disse samarbeidsparterne fra ressursbasen",
  "delete.contact.error": "Kunne ikke slette disse kontaktene. Vennligst prøv igjen.",
  "delete.contact.modal.title": "Slett disse kontaktene fra ressursbasen",
  "delete.lead.error": "Kunne ikke slette disse leads. Vennligst prøv igjen.",
  "delete.lead.modal.title": "Slett disse leads fra ressursbasen",
  "delete.member.error": "Kunne ikke slette disse medlemmene. Vennligst prøv igjen.",
  "delete.member.modal.title": "Slett disse medlemmene fra ressursbasen",
  "deleteValue": "Slett verdi",
  "editing": "Redigering",
  "eventCount": "Antall events",
  "excel.downloadTemplate": "Last ned mal",
  "excel.downloadTemplateTips": "For å gjøre det enklere med å importere inn data, anbefaler vi at dere laster ned vår Excel-mal",
  "femaleCEO": "Kvinnelig daglig leder",
  "femaleChairman": "Kvinnelig styreleder",
  "femaleFounder": "Kvinnelig gründer",
  "updateDataFromBrreg": "Oppdater data fra Brreg",
  "updateDataFromBrreg.description": "Hent informasjon fra Brønnøysundsregistrene",
  "files": "Filer",
  "forcedLiquidation": "Under tvangsavvikling",
  "gotoContactPage": "Gå til kontaktsiden",
  "gotoDetailPage": "Gå til detaljesiden",
  "import": "Importer",
  "import.alreadyInResourceBase": "Disse finnes fra før i ressursbasen, og vil ikke bli opprettet.",
  "import.amount": "Antall: {{ length }} stk",
  "import.invalidOrganizationNumber": "Ugyldige organisasjonsnummer",
  "import.invalidOrganizationNumber.description": "Her får du en liste med hvilke verdier som er ugyldige, hvorfor de er ugyldig, og hvilken rad de ble funnet på.",
  "import.member.noneToImport": "Ingen medlemmer å importere.",
  "import.noneToImport": "Ingen å importere",
  "import.template.associates": "Import-mal for samarbeidspartnere",
  "import.template.leads": "Import-mal for leads",
  "import.template.members": "Import-mal for medlemmer",
  "importAssociates": "Import samarbeidspartnere",
  "importContacts": "Importer kontakter",
  "importLeads": "Importer leads",
  "importMembers": "Importer medlemmer",
  "industry": "Bransje",
  "inkindKeptContactDeleted": "vil beholdes, selv om kontakter blir slettet.",
  "innovationSupport": "Innovasjonsstøtte",
  "intro": "Intro",
  "invalid.date": "Ugyldig dato",
  "invalidFileType": "Ugyldig filtype, vennligst velg et Excel-skjema likt malen.",
  "invalidOrgNumber": "Ugyldig org.nr format.",
  "invoicedDeductible": "Fakturert egenandel",
  "invoiceNumber": "Fakturanr.",
  "keepExistingValue": "Behold eksisterende verdi",
  "lead": "Lead",
  "leads": "Leads",
  "leads.excelImportError": "Noe gikk galt under importering av Excel-filen. Det kan være forskjell på ditt Excel-skjema og mal. Last ned mal og prøv igjen.",
  "leads.Imported": "{{ numberOfLeads }} leads importert!",
  "leads.ImportError": "Noe gikk galt under opprettelse av leads. Vennligst prøv igjen.",
  "leads.Importing": "Importerer leads...",
  "leads.noneToImport": "Ingen leads å importere",
  "liquidation": "Under avvikling",
  "logo": "Logo",
  "logoLimitationExplanation": "Logofiler må være enten i .jpg eller .png format og kan max være 1 MB (kun én logo per bedrift).",
  "fileUploadLimitationExplanation": "Du kan laste opp følgende filformater: *.pdf, *.doc, *.docx, *.dot, *.xls, *.xlsx, med en maksimal filstørrelse på 10MB per fil.",
  "mainContact": "Hovedkontakt",
  "markedRowsAlreadyRetired": "Markerte rader er allerede utmeldt",
  "marketValue": "Markedsverdi",
  "customer": "Kunde",
  "memberFee": "Medlemskontigent",
  "memberFeeDescription": "Her ligger all egeninnsats registrert på medlemmet på tvers av prosjekter, aktiviteter og eventer.",
  "memberFeeTitle": "Oversikt over medlemsbedriftens egeninnsats",
  "memberInformation": "Medlemsinformasjon",
  "memberProfile": "Medlemsprofil",
  "memberRetiredDescriptionPart1": "Dette medlemmet er meldt ut, utmeldingsdato:",
  "memberRetiredDescriptionPart2": "Medlemmet kan ikke endres før det meldes inn igjen.",
  "customers": "Kunder",
  "membersMayHaveConnectedContacts": "Disse medlemmene kan ha tilknyttet kontakter.",
  "missing.name": "Navn mangler",
  "missing.type": "Type mangler",
  "nace": "NACE-kode",
  "newContact": "Ny kontakt",
  "noContactsInMember": "Ingen kontakter tilknyttet dette medlemmet.",
  "noRowsMarkedRequired": "Ingen rader markert! Minst en rad må være markert for å utføre denne handlingen.",
  "numberOfEmployees": "Antall ansatte",
  "numberOfEmployeesLastYear": "Antall ansatte i fjor",
  "opportunities": "Henvendelser",
  "orderNumber": "Ordrenummer",
  "organization": "Organisering",
  "organizationNumber.invalidFormat": "Ugyldig format på organisasjonsnummer.",
  "participantsRemoved": "Deltagere ble fjernet",
  "projectCount": "Antall prosjekter",
  "readyForImport": "klar til import",
  "registeredTooMuch": "Registrert mottatt for mye støtte",
  "registratedHours": "Registrerte timer",
  "registration": "Registrering",
  "registration.businessEnterprise": "Reg. Foretaksregisteret",
  "registration.foundation": "Reg. Stiftelsesregisteret",
  "registration.legal": "Reg. Enhetsregisteret",
  "registration.nonProfit": "Reg. Frivillighetsregisteret",
  "registration.vat": "Reg. MVA-registeret",
  "removeAllContactsFromList": "Fjern alle kontakter fra listen",
  "removingParticipants": "Fjerner deltagere",
  "replaceExistingValue": "Erstatt eksisterende verdi med...",
  "retire.associate.error": "Kunne ikke melde ut disse samarbeidspartnerne. Vennligst prøv igjen.",
  "retire.associate.modal.title": "Meld ut disse samarbeidspartnerne fra ressursbasen",
  "retire.contact.error": "Kunne ikke melde ut disse kontaktene. Vennligst prøv igjen.",
  "retire.contact.modal.title": "Meld ut disse kontaktene fra ressursbasen",
  "retire.lead.error": "Kunne ikke melde ut disse leads. Vennligst prøv igjen.",
  "retire.lead.modal.title": "Meld ut disse leads fra ressursbasen",
  "retire.member.error": "Kunne ikke melde ut disse medlemmene. Vennligst prøv igjen.",
  "retire.member.modal.title": "Meld ut disse medlemmene fra ressursbasen",
  "searchForContacts": "Søk etter kontakter",
  "selectCompany": "Velg bedrift",
  "sumInnovationSupport": "Sum mottatt innovasjonsstøtte ffa næringshagen",
  "supportIntensity": "Støtteintensitet",
  "supportMarketValue": "Markedsverdi på innovasjonsstøttetjenester fra næringshagen",
  "tooMuchSupport": "For mye støtte",
  "uniqueParticipants": "Unike deltakere",
  "uniqueParticipantsOfMembers": "Av totalt {{participantsCount}} fordelt på {{membersCount}} medlemmer",
  "import.invalidEmailsFound": "Ugyldige e-postadresser funnet. Her får du en liste over de ugyldige verdiene, og hvilken rad de ble funnet på.",
  "import.duplicateEmailsFound": "Duplikate e-postadresser funnet. Her får du en liste over de ugyldige verdiene, og hvilken rad de ble funnet på.",
  "import.existsInResourceBase": "Disse finnes fra før i ressursbasen, og vil ikke bli opprettet.",
  "import.invalidOrgNoFound": "Ugyldige organisasjonsnummer funnet! Her får du en liste over de ugyldige verdiene, og hvilken rad de ble funnet på.",
  "import.contact.readyForImport": "{{ contacts }} kontakt(er) klar for import, og {{ leads }} lead(s) (bedrifter).",
  "import.template.contacts": "Import-mal for kontakter",
  "import.contact.noneToImport": "Ingen kontakter å importere",
  "showDuplicateEmails": "Vis duplikate e-postadresser",
  "showInvalidOrgNumbers": "Vis ugyldige organisasjonsnummer",
  "showExisting": "Vis eksisterende",
  "showInvalidEmails": "Vis ugyldige epostadresser",
  "selectMember": "Velg medlem",
  "memberContacts": "Kontakter tilknyttet dette medlemmet:",
  "noMemberContacts": "Dette medlemmet har ingen kontakter å anbefale kurs til",
  "contactsAlreadyRecommended": "Følgende kontakter har allerede fått anbefalt dette kurset:",
  "companyWithoutCategory": "Bedrift uten kategori",
  "notSetMemberNotification.title": "Det finnes bedrift(er) uten satt kategori",
  "notSetMemberNotification.description": "Disse burde få satt en kategori for å kunne beregne egeninnsats riktig. Klikk på \"Vis bedrifter uten kategori\" for å sette kategori på bedriftene.",
  "notSetMemberNotification.button.show": "Vis bedrifter uten kategori",
  "notSetMemberNotification.button.hide": "Skjul melding",
  "notSetContactMemberNotification.title": "Feil i egeninnsats? Tiltak kreves for å beregne riktig",
  "notSetContactMemberNotification.description": "For å beregne egeninnsats riktig, må alle kontakter være tilknyttet en bedrift. Du har kontakter som mangler tilknytning til en bedrift. Klikk på 'Vis kontakter uten bedrift' for å knytte en bedrift til disse kontaktene.",
  "notSetContactMemberNotification.button.text": "Vis kontakter uten bedrift",
  "notSetContactMemberNotification.toast.error.generic": "Kunne ikke oppdatere egeninnsats for kontaktene. Vennligst prøv igjen.",
  "notSetContactMemberNotification.toast.error.updateContact": "Kunne ikke oppdatere kontakt {{ name }}",
  "notSetContactMemberNotification.toast.error.updateInkind": "Kunne ikke oppdatere egeninnsats for kontakt {{ name }}",
  "notSetContactMemberNotification.modal.title": "Tilknytt kontakter til en bedrift",
  "notSetContactMemberNotification.modal.description": "Vi har foreslått mulige bedrifter til {{ suggestion }} kontakter, men det er fortsatt {{ missing }} kontakter uten tilknyttet bedrift.",
  "notSetContactMemberNotification.modal.description.suggestions": "Det er {{ count }} av {{ total }} kontakter er uten tilknyttet bedrift",
  "notSetContactMemberNotification.confirm.title": "Bekreftelse",
  "notSetContactMemberNotification.confirm.description": "{{ count }} kontakter har blitt oppdatert.",
  "notSetContactMemberNotification.confirm.missing": "{{ count }} kontakter er fortsatt uten bedrift. Vil du fortsette?",
  "notSetContactMemberNotification.confirm.missing.link": "Tilknytt til en bedrift",
  "notSetContactMemberNotification.modal.missingCompany": "Finner du ikke bedriften her? Opprett en ny under",
  "notSetContactMemberNotification.table.column.contact": "Kontakt",
  "notSetContactMemberNotification.table.column.company": "Velg bedrift",
  "notSetContactMemberNotification.table.subtitle.others": "Øvrige",
  "notSetContactMemberNotification.button.submit.text": "Bekreft og lagre",
  "notSetContactMemberNotification.button.cancel.text": "Avbryt",
  "contact.created.confirmation.text": "Kontakten <1>{{ name }}</1> er lagt til i kontaktlisten."
}
